  export enum periodeEnum {
      'Roční' = 1,
      'Pololetní' = 2,
      'Čtvrtletní' = 4,
      'Měsíční' = 12,
    }
